export default "__VITE_ASSET__wyAwyQO7h5ix5xRZ0IFJHQ__"